import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import UserMainApp from "../../layouts/UserMainApp";
import { MDBDataTable } from "mdbreact";
import moment from "moment";
import CreateAddress from "./CreateAddress";
// import EditAddress from "./EditAddress";
// import DeleteAddress from "./DeleteAddress";
import { useDispatch, useSelector } from "react-redux";
import { userActions } from "../../../redux/actions";
import Pagination from "../../includes/Pagination";
import PrimaryLoader from "../../includes/Loaders/PrimaryLoader";
import ReuseableSearchBar from "../../search/search";
import TableLoader from "../../includes/Loaders/TableLoader";
import PageNumber from "../../includes/PageNumber";

export default function AddressBook() {
  const {
    myAddresses,
    myAddressesLoader: loading,
    searching,
  } = useSelector((state) => state.users);

  const dispatch = useDispatch();

  let params = useParams();

  useEffect(() => {
    dispatch(userActions.getMyAddresses());
  }, [dispatch]);

  let addressData = myAddresses.data;

  function createTableData() {
    let dataToMap = addressData && addressData.data;
    if (Array.isArray(dataToMap)) {
      let outputArray = [];
      dataToMap.map((item, i) => {
        let singleRowArray = {
          title: item.title,
          address: item.address,
          country: item.country,
          state: item.state,
          city: item.city,
          created: moment(item.created_at).format("MMM Do, YYYY"),
          actions: (
            <div className="d-flex">
              {/* <EditAddress addressData={item} />
              <DeleteAddress addressData={item} /> */}
              <a
                href={`/user/address/details?id=${item.id}`}
                id={item.id}
                key={item.id}
                className="btn-small btn indigo text-white waves-effect waves-light btn mb-2 mr-1"
              >
                View
              </a>
            </div>
          ),
        };
        outputArray.push(singleRowArray);
        return true;
      });
      return outputArray;
    }
  }
  const dataSet = createTableData();

  const data = {
    columns: [
      {
        label: "Title",
        field: "title",
        sort: "asc",
        width: 150,
      },
      {
        label: "Street Address",
        field: "address",
        sort: "asc",
        width: 200,
      },
      {
        label: "City",
        field: "city",
        sort: "asc",
        width: 150,
      },
      {
        label: "State",
        field: "state",
        sort: "asc",
        width: 100,
      },
      {
        label: "Date Created",
        field: "created",
        sort: "asc",
        width: 100,
      },
      {
        label: "Actions",
        field: "actions",
        sort: "asc",
        width: 150,
      },
    ],
    rows: dataSet,
  };

  return (
    <UserMainApp>
      {loading ? (
        <PrimaryLoader />
      ) : (
        <div className="main-content-padding">
          <div className="main-content">
            <div className="d-flex justify-content-between mb-3">
              <h1 className="mr-2">Address Book</h1>
              <CreateAddress />
            </div>
            <div className="separator-breadcrumb border-top" />

            <div className="search-page">
              <PageNumber data={addressData} route="address" />
              <ReuseableSearchBar
                // companyId={company_id}
                page={params.page}
                searchAction={userActions.searchAddresses}
                clearSearchResultsAction={userActions.getMyAddresses}
              ></ReuseableSearchBar>
            </div>

            <div>
              {searching ? (
                <TableLoader />
              ) : (
                <MDBDataTable
                  responsive
                  theadColor="MDBTableHeader"
                  entries={8}
                  entriesOptions={[8, 10, 15]}
                  hover
                  noBottomColumns
                  bordered
                  maxHeight="400px"
                  data={data}
                  paging={false}
                  searching={false}
                />
              )}
            </div>
            <Pagination data={addressData} route="address" />
            {/* end of row*/}
            {/* end of main-content */}
          </div>
        </div>
      )}
    </UserMainApp>
  );
}
